/**
 * Discount App Storefront Script
 * Ottimizzato per Shopify Impact Theme (Maestrooo)
 */
(function () {
  'use strict';

  const APP_HOST = 'https://thomas-discounts.duckdns.org';
  const SHOP_DOMAIN = Shopify.shop;
  let activeCampaigns = [];

  async function init() {
    try {
      const res = await fetch(`${APP_HOST}/api/campaigns/storefront/${SHOP_DOMAIN}`);
      if (!res.ok) return;
      activeCampaigns = await res.json();
      if (!activeCampaigns.length) return;
      runOnPage();
      document.addEventListener('shopify:section:load', runOnPage);
      let lastUrl = location.href;
      new MutationObserver(() => {
        if (location.href !== lastUrl) { lastUrl = location.href; setTimeout(runOnPage, 500); }
      }).observe(document, { subtree: true, childList: true });
    } catch (e) { console.warn('[DiscountApp]', e); }
  }

  function runOnPage() {
    const url = window.location.pathname;
    const isProduct = url.includes('/products/');
    activeCampaigns.forEach(campaign => {
      try {
        if (campaign.type === 'volume_discount' && isProduct) renderVolumeTable(campaign);
      } catch(e) { console.warn('[DiscountApp] volume_discount error:', e); }
      try {
        if (campaign.type === 'buy_x_get_y' && isProduct) renderBXGYNotice(campaign);
      } catch(e) { console.warn('[DiscountApp] bxgy error:', e); }
      try {
        if (campaign.type === 'flash_sale') { renderCountdown(campaign); renderBadges(campaign); }
      } catch(e) { console.warn('[DiscountApp] flash_sale error:', e); }
      try {
        if (campaign.type === 'collection_discount') renderBadges(campaign);
      } catch(e) { console.warn('[DiscountApp] collection_discount error:', e); }
      try {
        if (campaign.type === 'customer_segment') renderSegmentNotice(campaign);
      } catch(e) { console.warn('[DiscountApp] segment error:', e); }
      try {
        if (campaign.badgeConfig?.show) renderBadges(campaign);
      } catch(e) { console.warn('[DiscountApp] badge error:', e); }
    });
  }

  function renderVolumeTable(campaign) {
    const tiers = campaign.config?.tiers;
    if (!tiers || !tiers.length) return;
    if (document.getElementById('da-volume-table')) document.getElementById('da-volume-table').remove();

    const insertTargets = [
      document.querySelector('product-form'),
      document.querySelector('.product-form'),
      document.querySelector('form[action*="/cart/add"]'),
      document.querySelector('.product-info'),
    ];
    const target = insertTargets.find(el => el !== null);
    if (!target) return;

    const accentColor = getComputedStyle(document.documentElement).getPropertyValue('--color-accent').trim() || '#000';
    const borderColor = getComputedStyle(document.documentElement).getPropertyValue('--color-border').trim() || '#e5e5e5';

    const table = document.createElement('div');
    table.id = 'da-volume-table';
    table.style.cssText = 'margin: 16px 0; font-family: inherit;';
    table.innerHTML = `
      <div style="border:1px solid ${borderColor};border-radius:6px;overflow:hidden;">
        <div style="background:${accentColor};color:#fff;padding:10px 16px;font-weight:700;font-size:13px;text-transform:uppercase;letter-spacing:0.05em;">
          🎉 Più compri, più risparmi!
        </div>
        <table style="width:100%;border-collapse:collapse;background:#fff;">
          <thead>
            <tr style="font-size:12px;color:#888;text-transform:uppercase;letter-spacing:0.05em;">
              <th style="padding:8px 16px;text-align:left;border-bottom:1px solid ${borderColor};">Compra</th>
              <th style="padding:8px 16px;text-align:left;border-bottom:1px solid ${borderColor};">Ottieni</th>
            </tr>
          </thead>
          <tbody>
            ${tiers.map((tier, i) => `
              <tr style="font-size:14px;${i % 2 !== 0 ? 'background:#f9f9f9;' : ''}">
                <td style="padding:9px 16px;border-bottom:1px solid ${borderColor}22;"><strong>${tier.minQty}+</strong> prodotti</td>
                <td style="padding:9px 16px;border-bottom:1px solid ${borderColor}22;color:#e44;"><strong>${tier.discount}${tier.type === 'percentage' ? '%' : '€'} Off</strong></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;

    const parent = target.closest('.product-info') || target.parentElement;
    if (parent) {
      try { parent.insertBefore(table, target); } 
      catch(e) { parent.appendChild(table); }
    }
  }

  function renderBXGYNotice(campaign) {
    const { buyQty, getQty, getDiscount, discountType } = campaign.config || {};
    if (!buyQty || !getQty) return;
    if (document.getElementById('da-bxgy-notice')) document.getElementById('da-bxgy-notice').remove();

    const targets = [
      document.querySelector('product-form'),
      document.querySelector('form[action*="/cart/add"]'),
    ];
    const target = targets.find(el => el !== null);
    if (!target) return;

    const discountText = discountType === 'percentage' && getDiscount === 100 ? 'GRATIS' : `${getDiscount}${discountType === 'percentage' ? '%' : '€'} di sconto`;
    const accentColor = getComputedStyle(document.documentElement).getPropertyValue('--color-accent').trim() || '#000';

    const notice = document.createElement('div');
    notice.id = 'da-bxgy-notice';
    notice.style.cssText = 'margin: 16px 0;';
    notice.innerHTML = `
      <div style="border:2px solid ${accentColor};border-radius:6px;padding:12px 16px;display:flex;align-items:center;gap:12px;">
        <span style="font-size:22px;flex-shrink:0;">🎁</span>
        <div>
          <div style="font-weight:700;font-size:14px;margin-bottom:2px;">Offerta Speciale: Compra ${buyQty}, prendi ${getQty} ${discountText}!</div>
          <div style="font-size:12px;color:#888;">Sconto applicato automaticamente al checkout</div>
        </div>
      </div>
    `;
    const parent = target.closest('.product-info') || target.parentElement;
    if (parent) {
      try { parent.insertBefore(notice, target); }
      catch(e) { parent.appendChild(notice); }
    }
  }

  function renderCountdown(campaign) {
    if (!campaign.endsAt) return;
    const endTime = new Date(campaign.endsAt).getTime();
    if (Date.now() > endTime) return;
    if (document.getElementById('da-countdown-bar')) return;

    const bar = document.createElement('div');
    bar.id = 'da-countdown-bar';
    bar.style.cssText = 'background:#000;color:#fff;text-align:center;padding:10px 20px;font-size:13px;font-weight:500;display:flex;justify-content:center;align-items:center;gap:16px;position:relative;z-index:200;';

    const stickyHeader = document.querySelector('sticky-header') || document.querySelector('header');
    if (stickyHeader?.parentElement) stickyHeader.parentElement.insertBefore(bar, stickyHeader.nextSibling);
    else document.body.insertBefore(bar, document.body.firstChild);

    function update() {
      const rem = endTime - Date.now();
      if (rem <= 0) { bar.remove(); return; }
      const h = Math.floor(rem / 3600000);
      const m = Math.floor((rem % 3600000) / 60000);
      const s = Math.floor((rem % 60000) / 1000);
      bar.innerHTML = `<span>🔥 <strong>${campaign.name}</strong></span><span style="background:rgba(255,255,255,0.15);padding:4px 14px;border-radius:4px;font-family:monospace;font-size:17px;font-weight:700;letter-spacing:3px;">${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}</span><span style="font-size:12px;opacity:0.8;">Finisce presto!</span>`;
    }
    update();
    setInterval(update, 1000);
  }

  function renderBadges(campaign) {
    const bc = campaign.badgeConfig;
    if (!bc || !bc.show || !bc.text) return;

    const cards = document.querySelectorAll('product-card, .product-card');
    cards.forEach(card => {
      if (card.querySelector(`.da-badge[data-campaign="${campaign.id}"]`)) return;
      let badgeList = card.querySelector('.badge-list');
      if (!badgeList) {
        const media = card.querySelector('a, .media') || card;
        badgeList = document.createElement('div');
        badgeList.className = 'badge-list';
        badgeList.style.cssText = 'position:absolute;top:12px;left:12px;z-index:5;display:flex;flex-direction:column;gap:6px;';
        if (window.getComputedStyle(media).position === 'static') media.style.position = 'relative';
        media.appendChild(badgeList);
      }
      const badge = document.createElement('div');
      badge.className = 'badge da-badge';
      badge.setAttribute('data-campaign', campaign.id);
      badge.style.cssText = `background:${bc.backgroundColor||'#000'};color:${bc.color||'#fff'};padding:4px 10px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;border-radius:2px;display:inline-block;`;
      badge.textContent = bc.text;
      badgeList.appendChild(badge);
    });

    const productBadgeList = document.querySelector('.product-badge-list, .product-label-list');
    if (productBadgeList && !productBadgeList.querySelector(`.da-badge[data-campaign="${campaign.id}"]`)) {
      const badge = document.createElement('div');
      badge.className = 'badge da-badge';
      badge.setAttribute('data-campaign', campaign.id);
      badge.style.cssText = `background:${bc.backgroundColor||'#000'};color:${bc.color||'#fff'};padding:5px 12px;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;border-radius:2px;`;
      badge.textContent = bc.text;
      productBadgeList.appendChild(badge);
    }
  }

  function renderSegmentNotice(campaign) {
    if (typeof ShopifyAnalytics === 'undefined') return;
    if (!ShopifyAnalytics.meta?.page?.customerId) return;
    if (document.getElementById('da-segment-notice')) return;
    const { discountPercentage, customerTag } = campaign.config || {};
    const target = document.querySelector('product-form, cart-items, .cart__items');
    if (!target) return;
    const notice = document.createElement('div');
    notice.id = 'da-segment-notice';
    notice.innerHTML = `<div style="border:1px solid #bbf7d0;background:#f0fdf4;border-radius:6px;padding:10px 16px;font-size:13px;color:#166534;display:flex;align-items:center;gap:8px;margin:12px 0;">⭐ Il tuo sconto <strong>${customerTag||'speciale'}</strong> del <strong>${discountPercentage}%</strong> è attivo!</div>`;
    try { target.parentElement.insertBefore(notice, target); }
    catch(e) { target.parentElement.appendChild(notice); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();